<template>
  <div>
    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <v-file-input
            v-for="input in normalizedFileInputs"
            :key="input.key"
            :label="input.label"
            v-model="selectedFiles[input.key]"
            :accept="input.accept"
            :multiple="input.multiple"
            :show-size="input.showSize"
            :chips="input.chips"
            :prepend-icon="input.prependIcon"
            :hint="input.hint"
            :persistent-hint="!!input.hint"
            :class="input.class"
            @change="onFileChange(input.key, $event)"
            :rules="input.required ? [rules.required] : []"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">Cancel</v-btn>
          <v-btn color="primary" :disabled="submitDisabled" @click="submit"
            >{{ submitText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "UploadFileModal",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "Upload File" },
    label: { type: String, default: "Select file" },
    accept: { type: String, default: "" },
    submitText: { type: String, default: "Upload" },
    fileInputs: { type: Array, default: () => [] },
  },
  data() {
    return {
      show: this.value,
      selectedFiles: {},
      rules: {
        required: (value) => this.hasFileValue(value) || "A file is required.",
      },
    };
  },
  computed: {
    normalizedFileInputs() {
      if (this.fileInputs.length > 0) {
        return this.fileInputs.map((input, index) => ({
          key: input.key || `file${index}`,
          label: input.label || this.label,
          accept: input.accept === undefined ? this.accept : input.accept,
          multiple: !!input.multiple,
          required: input.required !== false,
          showSize: input.showSize !== false,
          chips: !!input.chips,
          prependIcon: input.prependIcon,
          hint: input.hint,
          class: input.class || "",
        }));
      }

      return [
        {
          key: "file",
          label: this.label,
          accept: this.accept,
          multiple: false,
          required: true,
          showSize: true,
          chips: false,
          prependIcon: undefined,
          hint: undefined,
          class: "",
        },
      ];
    },
    submitDisabled() {
      return this.normalizedFileInputs.some(
        (input) =>
          input.required && !this.hasFileValue(this.selectedFiles[input.key]),
      );
    },
  },
  created() {
    this.resetFiles();
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.resetFiles();
      }
    },
    show(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    close() {
      this.show = false;
      this.resetFiles();
    },
    submit() {
      if (this.fileInputs.length > 0) {
        this.$emit("upload", { ...this.selectedFiles });
      } else {
        this.$emit("upload", this.selectedFiles.file);
      }
      this.close();
    },
    onFileChange(key, file) {
      this.$set(this.selectedFiles, key, file);
    },
    hasFileValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return !!value;
    },
    resetFiles() {
      const selectedFiles = {};
      this.normalizedFileInputs.forEach((input) => {
        selectedFiles[input.key] = input.multiple ? [] : null;
      });
      this.selectedFiles = selectedFiles;
    },
  },
};
</script>
